export default {
    path: 'index',
    component: () => import(/*webpackChunkName: 'pc-web-index'*/ '@views/web/home/index'),
    meta: {

    }
}
